import { Stack } from '@mui/material'
import { t } from 'i18next'
import { useEffect, useRef, useState } from 'react'

import Can from '../../Layout/Can/Can.jsx'
import Filter from '../../Layout/Dialogs/Filter.jsx'
import Count from '../../Shared/Components/Count.jsx'
import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'
import FilterGatewayArea from '../../Shared/Filters/Filters/GatewayArea.jsx'
import FilterGatewayStatus from '../../Shared/Filters/Filters/GatewayStatus.jsx'
import FilterGatewayTechnology from '../../Shared/Filters/Filters/GatewayTechnology.jsx'

const Filters = ({ itemsCount, filters, onChange }) => {
  const {
    currentUser: { isSuperAdmin }
  } = useAuth()

  const [selectedArea, setSelectedArea] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState(false)
  const [selectedTechnology, setSelectedTechnology] = useState(false)
  const [announcementUpdatePage, setAnnouncementUpdatePage] = useState('')
  const shouldAnnounceUpdatePage = useRef(false)
  const previousItemsCount = useRef(itemsCount)

  const handleOnDeleteArea = () => {
    onChange({
      ...filters,
      nearby: null
    })
    shouldAnnounceUpdatePage.current = true
  }

  const handleOnDeleteStatus = () => {
    onChange({
      ...filters,
      status: []
    })
    shouldAnnounceUpdatePage.current = true
  }

  const handleOnDeleteTechnology = () => {
    onChange({
      ...filters,
      technology: []
    })
    shouldAnnounceUpdatePage.current = true
  }

  const handleChangeGatewaysStatus = (data) => {
    onChange({
      ...filters,
      ...data
    })
  }
  const handleChangeGatewaysTechnology = (data) => {
    onChange({
      ...filters,
      ...data
    })
  }
  const handleChangeGatewayArea = (data) => {
    onChange({
      ...filters,
      ...data
    })
  }

  const handleFilterClose = () => {
    shouldAnnounceUpdatePage.current = true
    announceUpdatePage()
  }

  const getAnnouncementMessage = () => {
    if (itemsCount === 0) {
      return t('filters.accessibility.noItemsFound')
    } else if (itemsCount === 1) {
      return t('filters.accessibility.oneItemFound')
    } else {
      return t('filters.accessibility.itemsFound', { count: itemsCount })
    }
  }

  const announceUpdatePage = () => {
    setAnnouncementUpdatePage('')

    setTimeout(() => {
      setAnnouncementUpdatePage(getAnnouncementMessage())
    }, 100)
  }

  useEffect(() => {
    if (shouldAnnounceUpdatePage.current && previousItemsCount.current !== itemsCount) {
      announceUpdatePage()
      shouldAnnounceUpdatePage.current = false
    }
    previousItemsCount.current = itemsCount
  }, [itemsCount])

  useEffect(() => {
    const {
      nearby,
      status,
      technology
    } = filters

    setSelectedArea(!!nearby)
    setSelectedStatus(status?.length > 0)
    setSelectedTechnology(technology?.length > 0)
  }, [filters])


  const filterUnits = [
    {
      label: t('filters.gateways.status.label'),
      id: 'chip-filters-status',
      selected: selectedStatus,
      onDelete: handleOnDeleteStatus,
      onClose: handleFilterClose,
      hidden: !isSuperAdmin,
      content: (
        <FilterGatewayStatus
          filters={filters}
          onChange={handleChangeGatewaysStatus}
        />
      ),
      count: <Count itemsCount={itemsCount} />
    },
    {
      label: t('filters.gateways.technology.label'),
      id: 'chip-filters-technology',
      selected: selectedTechnology,
      onDelete: handleOnDeleteTechnology,
      onClose: handleFilterClose,
      hidden: !isSuperAdmin,
      content: (
        <FilterGatewayTechnology
          filters={filters}
          onChange={handleChangeGatewaysTechnology}
        />
      ),
      count: <Count itemsCount={itemsCount} />
    },
    {
      label: t('filters.gateways.area.label'),
      id: 'chip-filters-area',
      selected: selectedArea,
      onDelete: handleOnDeleteArea,
      onClose: handleFilterClose,
      hidden: !isSuperAdmin,
      content: (
        <FilterGatewayArea
          filters={filters}
          onChange={handleChangeGatewayArea}
        />
      ),
      count: <Count itemsCount={itemsCount} />
    }
  ]

  return (
    <>
      {/* Live region per annunci screen reader */}
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '-10000px',
          width: '1px',
          height: '1px',
          overflow: 'hidden'
        }}
      >
        {announcementUpdatePage}
      </div>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={2}
      >
        {[...filterUnits].map((e, i) => (
          <Can
            action="gateways_r"
            key={`device-filter-${i}`}
          >
            <Filter
              key={`device-filter-${i}`}
              id={e.id}
              onClick={e.onClick}
              onDelete={e.onDelete}
              onClose={e.onClose}
              selected={e.selected}
              title={e.label}
              hidden={e.hidden || false}
              content={e.content}
              count={e.count}
            />
          </Can>
        ))}
      </Stack>
    </>
  )
}

export default Filters
